import { Locale } from "date-fns/locale";
import { de } from "date-fns/locale/de";

import { LanguageType } from "@/translations";

export const locales: Record<LanguageType, Locale | undefined> = {
  [LanguageType.de]: de,
};
